<template>
  <b-modal ref="reassign-data-users"
           modal-class="task-modal v2-modal"
           @hide="error = ''">
    <template #modal-header>
      <div class="v2-modal__head">
        <div class="v2-modal__titles">
          <div class="v2-modal__eyebrow" v-if="task">{{ task.full_title || task.title }}</div>
          <h3 data-qid="reassign-data-users-title">{{ $t('tasks.re_assign.data_collection_title') }}</h3>
        </div>
        <span class="task-panel__nav" @click="hide" data-qid="reassign-data-users-close"><font-awesome-icon icon="times"/></span>
      </div>
    </template>

    <b-alert v-if="error.length" show variant="danger" data-qid="reassign-data-users-error">{{ error }}</b-alert>

    <b-form-group>
      <label>{{ $t('tasks.re_assign.data_collection_users_label') }}</label>
      <div class="multiselect-row">
        <multiselect v-model="selectedUsers"
                     :options="userOptions"
                     :multiple="true"
                     :taggable="false"
                     :internal-search="false"
                     :disabled="saving"
                     track-by="id"
                     label="name"
                     :select-label="$t('system.dropdown_select_label')"
                     :selected-label="$t('system.dropdown_selected_label')"
                     :deselect-label="$t('system.dropdown_deselect_label')"
                     :placeholder="$t('tasks.re_assign.users_placeholder')"
                     @search-change="loadUsers"
                     data-qid="reassign-data-users-select"
        >
          <template slot="tag" slot-scope="props">
            <span class="mr-3 user-tag">
              <Avatar :object="props.option" size="xs"></Avatar>
              <span class="ml-2">{{ props.option.name }}</span>
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <UserDropdownOption :user="props.option"></UserDropdownOption>
          </template>
          <template slot="noOptions">{{ $t('system.no_results') }}</template>
        </multiselect>
        <!-- Someone who isn't a user yet can be invited and then picked -->
        <UserInviteModal :buttonType="'small'" :buttonDisabled="saving" @reloadUserList="loadUsers()"></UserInviteModal>
      </div>
      <small class="form-text text-muted">{{ $t('tasks.re_assign.data_collection_hint') }}</small>
    </b-form-group>

    <template #modal-footer>
      <div class="v2-modal__footer">
        <b-button variant="secondary" @click="hide" data-qid="reassign-data-users-cancel">{{ $t('projects.create.cancel') }}</b-button>
        <b-button variant="success"
                  :disabled="saving || !selectedUsers.length"
                  @click="save"
                  data-qid="reassign-data-users-save"
        >
          <font-awesome-icon v-if="saving" icon="spinner" size="sm" class="fa-spin mr-1"/>
          {{ $t('tasks.re_assign_button') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import Avatar from '@/components/Avatar.vue';
import UserDropdownOption from '@/components/UserDropdownOption.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';

// Replace the documentation collection assignees of one task (Home and the task panel)
export default {
  name: 'DataCollectionReassignModal',
  components: {
    Avatar,
    UserDropdownOption,
    UserInviteModal
  },
  data() {
    return {
      task: null,
      users: [],
      selectedUsers: [],
      saving: false,
      error: ''
    };
  },
  computed: {
    userOptions() {
      return _.uniqBy(this.selectedUsers.concat(this.users), 'id');
    }
  },
  methods: {
    show(task) {
      this.task = task;
      this.error = '';
      this.saving = false;
      this.selectedUsers = _.cloneDeep(task.data_users || []);
      this.loadUsers();
      this.$refs['reassign-data-users'].show();
      // The row on Home has no assignees: take them from the full task
      if (!task.data_users) {
        piincHttp.get('tasks/' + task.id).then(response => {
          if (this.task && this.task.id === task.id) {
            this.task = response.data;
            this.selectedUsers = _.cloneDeep(response.data.data_users || []);
          }
        }, () => {});
      }
    },
    hide() {
      this.$refs['reassign-data-users'].hide();
    },
    loadUsers(query) {
      piincHttp.get('users', { params: {
        client: this.$store.state.client.id,
        keyword: query ? query : undefined,
        per_page: 100
      } }).then(response => {
        this.users = response.data.items;
      }, () => {});
    },
    save() {
      const user = this.$store.state.user;
      const ids = _.map(this.selectedUsers, 'id');
      this.saving = true;
      this.error = '';
      piincHttp.put('tasks/' + this.task.id, {
        data_users: ids,
        reasign: 'replace'
      }).then(response => {
        this.saving = false;
        this.hide();
        this.$toastr('success', this.$t('tasks.re_assign.success'));
        // Whoever re-assigned the task away from themselves no longer has it on their list
        this.$emit('saved', { task: response.data, removedSelf: !!(user && !ids.includes(user.id)) });
      }, error => {
        this.saving = false;
        this.error = error.data && error.data.message ? error.data.message : '';
      });
    }
  }
};
</script>
